package ru.villawonka.app.presentation.design.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Colors
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.ui.tooling.preview.Preview
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.AppTheme

@Composable
fun AppBadge(
    text: String? = null,
    type: AppBadgeType
) {
    Box(
        modifier = Modifier
            .background(
                color = when (type) {
                    AppBadgeType.STANDART -> MaterialTheme.colors.filledBadgeBackgroundStandart
                    AppBadgeType.SALE -> MaterialTheme.colors.filledBadgeBackgroundSale
                    AppBadgeType.INFO -> MaterialTheme.colors.filledBadgeBackgroundInfo
                },
                shape = RoundedCornerShape(8.dp)
            )
            .let {
                if (text.isNullOrBlank().not()) {
                    it.padding(
                        vertical = 4.dp,
                        horizontal = 10.dp
                    )
                } else {
                    it.size(10.dp)
                }
            }
    ) {
        text?.let {
            Text(
                text = it,
                style = AppTextStyles.labelSmallBold,
                color = when (type) {
                    AppBadgeType.STANDART -> MaterialTheme.colors.filledBadgeContentEnabled
                    AppBadgeType.SALE,
                    AppBadgeType.INFO -> MaterialTheme.colors.filledBadgeContentInverted
                }
            )
        }
    }
}

enum class AppBadgeType {
    STANDART,
    SALE,
    INFO
}

val Colors.filledBadgeBackgroundInfo
    get() = if (isLight) AppColors.blue500 else AppColors.blue500

val Colors.filledBadgeBackgroundSale
    get() = if (isLight) AppColors.pink600 else AppColors.pink600

val Colors.filledBadgeBackgroundStandart
    get() = if (isLight) AppColors.grayLight100 else AppColors.grayDark800

val Colors.filledBadgeContentInverted
    get() = if (isLight) AppColors.grayLight50 else AppColors.grayDark50

val Colors.filledBadgeContentEnabled
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

@Preview
@Composable
private fun Preview() {
    Column {
        AppTheme(isDarkTheme = false) {
            Row(
                modifier = Modifier
                    .background(Color.White)
                    .padding(16.dp)
            ) {
                AppBadge(
                    text = "Standart",
                    type = AppBadgeType.STANDART
                )
                AppSpacer(8.dp)
                AppBadge(
                    text = "Sale",
                    type = AppBadgeType.SALE
                )
                AppSpacer(8.dp)
                AppBadge(
                    text = "Info",
                    type = AppBadgeType.INFO
                )
                AppSpacer(8.dp)
                AppBadge(
                    type = AppBadgeType.STANDART
                )
                AppSpacer(8.dp)
                AppBadge(
                    type = AppBadgeType.SALE
                )
                AppSpacer(8.dp)
                AppBadge(
                    type = AppBadgeType.INFO
                )
                AppSpacer(8.dp)
            }
        }
        AppTheme(isDarkTheme = true) {
            Row(
                modifier = Modifier
                    .background(Color.Black)
                    .padding(16.dp)
            ) {
                AppBadge(
                    text = "Standart",
                    type = AppBadgeType.STANDART
                )
                AppSpacer(8.dp)
                AppBadge(
                    text = "Sale",
                    type = AppBadgeType.SALE
                )
                AppSpacer(8.dp)
                AppBadge(
                    text = "Info",
                    type = AppBadgeType.INFO
                )
                AppSpacer(8.dp)
                AppBadge(
                    type = AppBadgeType.STANDART
                )
                AppSpacer(8.dp)
                AppBadge(
                    type = AppBadgeType.SALE
                )
                AppSpacer(8.dp)
                AppBadge(
                    type = AppBadgeType.INFO
                )
                AppSpacer(8.dp)
            }
        }
    }
}


